import script from "./MallMyLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallMyLayout.vue?vue&type=script&setup=true&lang=ts"

import "./MallMyLayout.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__